import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-required",
  templateUrl: "./field-set-required.component.html",
})
export class FieldSetRequiredComponent {
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
